module.exports = __webpack_public_path__ + "static/media/creative-agency.dca49a7e.jpg";